import { CustomRuleAlertAPI } from '@analyzer/client';
import { Alert, AlertTitle, Box, Card, CardContent, Typography } from '@mui/material';
import SummarizedLink from '../url.js';
import { getSeverityColor } from './severity.js';

export function CustomRuleAlert({ alert }: { alert: CustomRuleAlertAPI }) {
  return (
    <Box>
      <Alert severity={getSeverityColor(alert.severity)} sx={{ mb: 2 }}>
        <AlertTitle>{alert.name}</AlertTitle>
        <Typography variant="body2">{alert.message}</Typography>
      </Alert>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Matching Requests
          </Typography>
          {alert.requests.map((item, index) => (
            <Typography key={index} variant="body2">
              <SummarizedLink url={item.request_url} />
            </Typography>
          ))}
        </CardContent>
      </Card>
    </Box>
  );
}
